import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch } from 'react-redux';

import { forceLoadingReducer } from './reducers';

import { cmsApi } from 'api/cmsApi';
import {
  fspCompApi,
  fspMatchApi,
  fspCompstatsApi,
  fspMatchstatsApi,
  fspStandingsApi,
  fspDomesticApi,
  fspPssApi,
} from 'api/fspApi';
import { sponsorsApi } from 'api/sponsorsApi';

const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [fspCompApi.reducerPath]: fspCompApi.reducer,
    [fspMatchApi.reducerPath]: fspMatchApi.reducer,
    [fspCompstatsApi.reducerPath]: fspCompstatsApi.reducer,
    [fspMatchstatsApi.reducerPath]: fspMatchstatsApi.reducer,
    [fspStandingsApi.reducerPath]: fspStandingsApi.reducer,
    [fspDomesticApi.reducerPath]: fspDomesticApi.reducer,
    [fspPssApi.reducerPath]: fspPssApi.reducer,
    [cmsApi.reducerPath]: cmsApi.reducer,
    [sponsorsApi.reducerPath]: sponsorsApi.reducer,
    forceLoading: forceLoadingReducer,
  },
  // FIXME: RTK-Query middleware is not compatible in types

  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware().concat([
      fspCompApi.middleware,
      fspMatchApi.middleware,
      fspCompstatsApi.middleware,
      fspMatchstatsApi.middleware,
      fspStandingsApi.middleware,
      fspDomesticApi.middleware,
      fspPssApi.middleware,
      cmsApi.middleware,
      sponsorsApi.middleware,
    ]),
});

setupListeners(store.dispatch);

// Pre-fetch stat definitions so they're cached before components need them
(store.dispatch as any)(fspCompstatsApi.endpoints.getDefinitions.initiate());
(store.dispatch as any)(fspMatchstatsApi.endpoints.getMatchStatDefinitions.initiate());

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type RootState = ReturnType<typeof store.getState>;
export default store;
